import { render } from "./vendorInfo.vue?vue&type=template&id=385e97c9"
import script from "./vendorInfo.vue?vue&type=script&lang=js"
export * from "./vendorInfo.vue?vue&type=script&lang=js"

import "./vendorInfo.vue?vue&type=style&index=0&id=385e97c9&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__